import styled from 'styled-components'
import { themeColor } from '../../util/themeLenses'
export const Container = styled.svg`
    role: slider;
    overflow: visible;
    outline: none;
    touch-action: manipulation;
    tabindex: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
`
export const RoundTrackContainer = styled.circle`
    border-radius: 2px;
    stroke-width: ${({strokeWidth}) => strokeWidth};
    stroke: ${({color}) => color};
    stroke-linecap: round;
    fill: none;
`

export const ProgressBar = styled.circle.attrs(props => ({
    style: {
        strokeDashoffset: props.strokeDashoffset,
        stroke: props.color
    }}))`
    stroke-width: ${({strokeWidth}) => strokeWidth};
    stroke-linecap: round;
    pointer-events: none;
    stroke-dasharray: ${({strokeDasharray}) => strokeDasharray};
    transform: ${({size}) => `rotate(-90deg) translate(-${size}px)`};
    fill: none;
`

export const ProgressCircle = styled.circle`
    pointer-events: none;
    fill: ${({progressColor}) => themeColor(progressColor)};
`